<template>
  <div class="body flex-col">
    <!-- banner -->
    <div class="top flex-row">
      <div class="banner-contact">
        <el-carousel
          :interval="2500"
          height="335px"
          indicator-position="outside"
          arrow="never"
        >
          <el-carousel-item v-for="item in bannerlist" :key="item.id">
            <div class="carouseData">
              <img
                alt=""
                :src="item.imageUrl || placeholder"
                class="carouseImg"
                style=""
                @click="toBlogDetail(item)"
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="hot flex-col">
        <div class="hot-head flex-row">
          <img src="@/assets/images/digitalIcon2.png" alt="" class="hot-img" />
          <div class="hot-title">{{ $t("热点资讯") }}</div>
          <!-- <div class="hot-change" @click="changeTop()">{{$t("换一换")}}</div> -->
        </div>
        <div class="hot-body flex-col">
          <div
            class="hot-box flex-row"
            v-for="(item, index) in hotList"
            :key="item.id"
            @click="toBlogDetail(item)"
          >
            <div :class="[index > 2 ? 'number' : 'number1']">
              {{ index + 1 }}
            </div>
            <div class="title" v-html="item.title"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- news -->
    <div class="bottom flex-row">
      <div class="news flex-col">
        <div
          class="box flex-row"
          v-for="item in dataList"
          :key="item.id"
          @click="toBlogDetail(item)"
        >
          <img :src="item.imageUrl" alt="" class="img" v-if="item.imageUrl" />
          <div class="contentRight">
            <!-- <div class="title">{{ item.title }}</div> -->
            <div class="title" v-html="item.title"></div>
            <div class="text">{{ item.description }}</div>
            <div class="time">{{ item.publishTime }}</div>
          </div>
        </div>
        <div class="loadingMoreButton justify-center">
          <div class="button" @click="loadMore()">{{ $t(this.loadText) }}</div>
        </div>
      </div>
      <div class="hot hot2 flex-col">
        <div class="hot-head flex-row">
          <img src="@/assets/images/digitalIcon1.png" alt="" class="hot-img" />
          <div class="hot-title">{{ $t("最新资讯") }}</div>
          <!-- <div class="hot-change" @click="changeBanner2()">{{$t("换一换")}}</div> -->
        </div>
        <div class="hot-body flex-col">
          <div
            class="hot-box flex-col"
            v-for="item in latestList"
            :key="item.id"
            @click="toBlogDetail(item)"
          >
            <div class="flex-row">
              <div class="dot">·</div>
              <div class="title" v-html="item.title"></div>
            </div>
            <div class="hot-time flex-col">🕑 {{ item.publishTime }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getBanners,
  getRecommends,
  getLatests,
  getArticles,
} from "@/config/api.js";
import { Carousel, CarouselItem } from "element-ui";
import Vue from "vue";
Vue.use(Carousel);
Vue.use(CarouselItem);
export default {
  data() {
    return {
      loadText: "加载更多",
      topPage: 1,
      bannerPage: 1,
      page: 1,
      bannerlist: [],
      hotList: [],
      latestList: [],
      topList: [],
      dataList: [],
      blogList: [],
      blogValue: "",
      initialValue: 6,
      timestamp: new Date().getTime(),
      data: {
        head: {
          method: "information_list",
          version: "3.0.1",
          timestamp: this.timestamp,
        },
        body: {
          timestamp: this.timestamp,
          size: this.initialValue,
          appType: "3",
        },
      },
      blogDetailKey: "",
      dialogVisible: false,
      isShowMore: false,
    };
  },

  created() {
    if (this.$route.query.hasOwnProperty("lang")) {
      localStorage.setItem("sys-locale", this.$route.query.lang);
      this.$i18n.locale = this.$route.query.lang;
    }
    this.getBannerArticles();
    this.getRecommendArticles();
    this.getLatestArticles();
    this.requestgetArticles();
  },
  methods: {
    //推荐文章banner
    async getBannerArticles() {
      const param = { type: 0, pc: 3 };
      getBanners(param).then((res) => {
        console.log("getBannerArticles in home page ====", res.data.data);
        if (res.data.data) {
          this.bannerlist = res.data.data;
        }
      });
    },

    // 推荐快讯
    async getRecommendArticles() {
      const param = { type: 0, pc: 8 };
      getRecommends(param).then((res) => {
        console.log("getRecommendArticles in home===", res.data.data);
        if (res.data.data.length > 0) {
          this.hotList = res.data.data;
        }
      });
    },

    // 最新快讯
    async getLatestArticles() {
      const param = { type: 0, pc: 8 };
      getLatests(param).then((res) => {
        console.log("getLatestArticles in home===", res.data.data);
        if (res.data.data.length > 0) {
          this.latestList = res.data.data;
        }
      });
    },

    changeBanner2() {
      this.bannerPage++;
      this.requestgetArticleRecommend2();
    },
    //推荐文章Top
    async requestgetArticleTop() {
      // var param = { page: this.topPage, type: 1, size: 8 };
      // getArticleRecommend(param).then((res) => {
      //   console.log("getArticleRecommend===", res.data);
      //   if (res.data.data.length>0) {
      //     this.topList = res.data.data;
      //   }
      // });
    },
    changeTop() {
      this.topPage++;
      this.requestgetArticleTop();
    },

    //全部文章
    requestgetArticles() {
      var param = { pn: this.page, pc: 10, status: "1" };
      getArticles(param).then((res) => {
        console.log("requestgetArticles in home page ====", res.data);
        if (res.data) {
          for (let i = 0; i < res.data.data.length; i++) {
            this.dataList.push(res.data.data[i]);
          }
          if (res.data.data.length == 0) {
            this.loadText = "暂无更多";
          }
        }
      });
    },
    loadMore() {
      this.page++;
      this.requestgetArticles();
    },
    toBlogDetail(item) {
      this.blogDetailKey = item.id;
      this.$router.push({
        path: "/detail",
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.body {
  height: 100%;
  width: 100%;
  // background: #232323;
  padding: 100px 10%;
  box-sizing: border-box;
  color: #1f1f22;

  .top {
    padding: 0% 0% 0% 0%;
  }
  .banner-contact {
    // background: #999999;
    width: 66%;
    margin-right: 4%;
    height: 350px;
    border-radius: 10px;
    .el-carousel__item h3 {
      opacity: 1;
      margin: 0;
      border-radius: 10px;
    }
    .el-carousel__item:nth-child(2n) {
      height: 100%;
      // background: #ffffff;
      border-radius: 10px;
    }

    .el-carousel__item:nth-child(2n + 1) {
      height: 100%;
      // background: #ffffff;
      border-radius: 10px;
    }

    .carouseData {
      display: flex;
      line-height: 100%;
      opacity: 1;
      align-items: center;
      // background: blue;
      height: 100%;
      border-radius: 10px;
      .carouseImg {
        width: 100%;
        height: 100%;
        border-radius: 10px;
        object-fit: cover;
        // background: red;
      }
      .carouseTitle {
        left: 0;
        background: rgba(255, 255, 255, 0.1);
        border: 2px solid;
        border-image: radial-gradient(
            circle,
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 0)
          )
          2 2;
        backdrop-filter: blur(19px);
      }
    }
  }

  .hot {
    width: 27%;
    // background: pink;
    height: 360px;
    margin: 0 0px 0 3%;

    .hot-head {
      width: 100%;
      height: 30px;
      line-height: 30px;
      font-size: 17px;
      .hot-img {
        padding: 0px 10px 0 0px;
        width: 12%;
        height: 100%;
        object-fit: contain;
      }
      .hot-title {
        margin-left: 10px;
        width: 65%;
        height: 100%;
        color: #1f1f22;
        // background: purple;
        white-space: nowrap;
      }
      .hot-change {
        width: 50px;
        height: 100%;
        font-size: 15px;
        text-align: right;
        cursor: pointer;
      }
    }

    .hot-body {
      margin-top: 20px;
      height: 80%;
      //background: yellow;
      overflow: hidden;
      border: solid 0.08em #eeeeee;
      border-radius: 10px;
      padding: 10px;
    }
    .hot-box {
      padding: 7px 10px;
      height: auto;
      line-height: 20px;

      .number {
        width: 25px;
        height: 20px;
        text-align: center;
        color: white;
        background: rgb(177, 177, 177);
        border-radius: 0 10px 0 10px;
      }
      .number1 {
        width: 25px;
        height: 20px;
        text-align: center;
        color: white;
        background: rgb(230, 63, 21);
        border-radius: 0 10px 0 10px;
      }
      .title {
        font-size: 13px;
        height: 20px;
        padding: 0px 15px;
        width: 95%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
      }
      .dot {
        font-size: 18px;
        font-weight: 600;
        line-height: 20px;
        text-align: center;
        color: #1f1f22;
        width: 5px;
      }
      .hot-time {
        margin: 0px 20px 0px 20px;
        line-height: 40px;
        color: #a0a0a9;
        border-bottom: 1px solid #f5f5f5;
      }
    }
  }
  .hot2 {
    height: 755px;
  }
  .bottom {
    margin-top: 20px;
  }
  .news {
    height: auto;
    width: 70%;
    // background: blueviolet;
    .loadingMoreButton {
      height: 60px;
      text-align: center;
      width: 100%;
      cursor: pointer;

      .button {
        width: 140px;
        height: 30px;
        line-height: 30px;
        border-radius: 15px;
        background: gainsboro;
      }
    }
    .box {
      height: 130px;
      width: 90%;
      //  background: yellow;
      margin-bottom: 15px;
      padding: 10px 0;
    }
    .img {
      height: 100%;
      width: 20%;
      background: rgb(214, 214, 214);
      justify-content: center;
      object-fit: cover;
      border-radius: 10px;
      margin: 0 20px 0 0;
    }
    .contentRight {
      height: 100%;
      width: 80%;
      padding: 0 0 0 0px;
      // background: purple;
      .title {
        line-height: 30px;
        height: 30px;
        font-size: 15px;
        font-weight: 550;
        width: 100%;
        color: #1f1f22;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
      }
      .text {
        width: 100%;
        line-height: 20px;
        height: 40px;
        font-size: 12px;
        color: #767680;

        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .time {
        height: 20px;
        width: 100%;
        margin-top: 20px;
        line-height: 20px;
        // background: blue;
        color: #767680;
        font-size: 12px;
      }
    }
  }
}
</style>